
/* eslint-disable no-useless-escape */
import Vue from "vue";
export default {
  methods: {
    showNotifyWarning(msg, time) {
      Vue.prototype.$vs.notify({
        title: "Atenção",
        text: msg,
        color: "warning",
        icon: "error_outline",
        time: time,
        position: "top-right",
      });
    },
    showNotifyError(msg, time) {
      if (time === undefined || time === null)
        time = 9000;
      Vue.prototype.$vs.notify({
        title: "Atenção",
        text: msg + ". Entre em contato com a equipe de atendimento para informar o ocorrido através do e-mail: contato@filoo.com.br ou pelo whatsapp 11 99650-7610.",
        color: "danger",
        click: () => {
          window.open("https://api.whatsapp.com/send?phone=55011996507610&text=Sua%20mensagem%20aqui", "_blank");
        },
        time: time,
        icon: "cancel",
        position: "top-right",
      });
    },
    showNotifySuccess(title, msg, time) {
      Vue.prototype.$vs.notify({
        title: title,
        text: msg,
        color: "success",
        icon: "verified_user",
        time: time,
        position: "top-right",
      });
    },
    isEmpty(obj) {
      for (const prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
      }

      return true;
    },
    maskMoney(value) {
      const formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      const newValue = parseFloat(value);

      const newValueFormat = formatter.format(newValue);

      return newValueFormat;
    },
    maskMoneyWithoutStyle(value) {
      const formatter = new Intl.NumberFormat("pt-BR", {
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      const newValue = parseFloat(value);

      const newValueFormat = formatter.format(newValue);

      return newValueFormat;
    },
    maskPhone(__phone) {
      if (__phone === null || __phone === undefined || __phone === "") {
        return "Sem registro";
      } else {
        var pt = /[()\- ]+/gi
        __phone = __phone.replace(pt, "");
        __phone = "(" + __phone.substr(0, 2) + ") " + __phone.substr(2, 5) + "-" + __phone.substr(6, 4);
        return __phone;
      }
    },
    maskCelPhone(v) {
      if (v === null || v === undefined || v === "") {
        return "";
      } else {
        v = v.replace(/\D/g, "");             		//Remove tudo o que não é dígito
        v = v.replace(/^(\d{2})(\d)/g, "$1 $2"); //Coloca parênteses em volta dos dois primeiros dígitos
        v = v.replace(/(\d)(\d{4})$/, "$1-$2");    //Coloca hífen entre o quarto e o quinto dígitos
        return v.substr(0, 15);
      }

    },
    maskZipcode(v) {
      if (v === null || v === undefined || v === "") {
        return "";
      } else {
        v = v.replace(/D/g, "")                //Remove tudo o que não é dígito
        v = v.replace(/^(\d{5})(\d)/, "$1-$2") //Esse é tão fácil que não merece explicações
        return v
      }
    },
    maskRg(v) {
      if (v === null || v === undefined || v === "") {
        return ""
      }
      else {
        v = v.replace(/\D/g, "");
        v = v.replace(/(\d{2})(\d{3})(\d{3})(\d{1})$/, "$1.$2.$3-$4");
        return v;
      }
    },
    maskCpf(cpf) {
      if (cpf === null || cpf === undefined || cpf === "") {
        return "";
      } else {
        if (cpf.length > 14) {
          return "";
        }
        cpf = cpf.replace(/[^\d]/g, "");
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
    },
    maskCnpj(value) {
      if (value === null || value === undefined || value === "") {
        return "";
      } else {
        return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
      }
    },
    validateEmail(email) {
      const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return emailReg.test(email);
    },
    validatePhone(phone) {
      const brazilianPhoneRegex = /^\(\d{2}\) \d{4,5}-\d{4}$/gi;
      return brazilianPhoneRegex.test(phone);
    },
    getDay(dateHour) {
      return dateHour.substring(0, 10);
    },
    getHour(dateHour) {
      return dateHour.substring(11, 16);
    },

    testNullUndefinedEmpty(field) {
      if (field == "" || field == undefined || field == null)
        return true;
      else
        return false;
    },
    testValidName(name){
      if(this.testNullUndefinedEmpty(name)){
        return false;
      } else {
        if(this.testFullName(name) == false){
          return false;
        }
        if(name.length < 5){
          return false;
        }
        if(name.trim().length == 0){
          return false;
        }
      }
      return true;
    },
    testFullAddress(address) {
      if(this.testNullUndefinedEmpty(address)){
        return false;
      } else {
        const addressSpaceLocation = address.indexOf(" ");
        const addressSize = address.length;
        if (addressSpaceLocation <= 1 || addressSpaceLocation >= addressSize - 1) {
          return false;
        }
        if(addressSize < 3){
          return false;
        }
        if(address.trim().length == 0){
          return false;
        }
      }
      return true;
    },
    testFullName(word){
      const verify = !!word.match(/[A-ZÀ-ú][a-zà-ú]* [A-ZÀ-ú][a-zà-ú]*/)
      return verify;     
    },
    validateCPF(cpf) {
      if (cpf == null || cpf == undefined) return false;
      cpf = cpf.replace(/\D/g, "");
      if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
      let result = true;
      [9, 10].forEach(function (j) {
        let soma = 0, r;
        cpf.split(/(?=)/).splice(0, j).forEach(function (e, i) {
          soma += parseInt(e) * ((j + 2) - (i + 1));
        });
        r = soma % 11;
        r = (r < 2) ? 0 : 11 - r;
        if (r != cpf.substring(j, j + 1)) result = false;
      });
      return result;
    },
    validateCNPJ(cnpj) {
      if (cnpj == null || cnpj == undefined || cnpj == "") return false;
      cnpj = cnpj.toString().replace(/[^\d]+/g, "");
      if (cnpj.length != 14)
        return false;
      // Elimina CNPJs invalidos conhecidos
      if (cnpj == "00000000000000" ||
                cnpj == "11111111111111" ||
                cnpj == "22222222222222" ||
                cnpj == "33333333333333" ||
                cnpj == "44444444444444" ||
                cnpj == "55555555555555" ||
                cnpj == "66666666666666" ||
                cnpj == "77777777777777" ||
                cnpj == "88888888888888" ||
                cnpj == "99999999999999")
        return false;
      // Valida DVs
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0, tamanho);
      const digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
          pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0))
        return false;
      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
          pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1)) {
        return false;
      }
      return true;
    },
    formatDate(dateStr) {
      var dArr = null;
      dArr = dateStr.split("-"); // ex input "2010-01-18"
      return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0); //ex out: "18/01/10"
    },
    trim(e) {
      var espacos = /\s/g;
      return e.replace(espacos, "");
    },
    round(value, exp) {
      if (typeof exp === "undefined" || +exp === 0) return Math.round(value);

      value = +value;
      exp = +exp;

      if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0))
        return NaN;

      // Shift
      value = value.toString().split("e");
      value = Math.round(+(value[0] + "e" + (value[1] ? +value[1] + exp : exp)));

      // Shift back
      value = value.toString().split("e");
      return +(value[0] + "e" + (value[1] ? +value[1] - exp : -exp));
    },
    isDate(input) {
      var status = false;
      if (!input || input.length <= 0) {
        status = false;
      } else {
        var result = new Date(input);
        if (result == "Invalid Date") {
          status = false;
        } else {
          status = true;
        }
      }
      return status;
    },
    getChromeVersion () {     
      var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
      return raw ? parseInt(raw[2], 10) : false;
    },
    dateFormatted(date) {
      var day = date.split("/")[0];
      var month = date.split("/")[1];
      var year = date.split("/")[2];
      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
    },
    removeSpecialCharactersAndAccents(word){
      let formattedWord = "";
      if(this.testNullUndefinedEmpty(word)){
        return;
      } else {
        formattedWord = word.normalize("NFD").replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, "");
        return  formattedWord;
      }    
    },
    onlyFirstLetterCapitalized(text){
      if(this.testNullUndefinedEmpty(text)){
        return;
      } else {
        var words = text.toLowerCase().split(" ");
        for (var a = 0; a < words.length; a++) {
          var w = words[a];
          words[a] = this.testNullUndefinedEmpty(w[0])? "":  w[0].toUpperCase() + w.slice(1);
        }
        return words.join(" ");
      }
    }, 
  },
}
